import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DeferredAsyncComponent from 'components/DeferredAsyncComponent';

const Desktop = DeferredAsyncComponent(() => import(/* webpackChunkName: "ChatPartial.desktop" */ './desktop'), null);

const ChatPartial = ({ layout, canShowChat }) => (canShowChat && layout === 'desktop' ? <Desktop /> : null);

ChatPartial.propTypes = {
  layout: PropTypes.string.isRequired,
  canShowChat: PropTypes.bool.isRequired,
};

const selector = state => ({
  layout: state.view.layout,
  canShowChat: state.session.canShowChat,
});

export default connect(selector, {})(ChatPartial);
